import React from "react";
import { Box, Container, Typography } from "@mui/material";

const CustomGraphTooltip = ({
  active,
  payload,
  label,
  chartData,
  ...props
}) => {
  if (!active || !label) {
    return null;
  }
  const data = chartData.find((data) => data.year === label);

  if (!data) return null;

  return (
    <Container
      sx={{
        backgroundColor: "white",
        width: "auto",
        padding: "10px",
        borderRadius: "10px",
      }}
    >
      <Box sx={{ paddingBottom: "5px" }}>
        <Typography variant="h6">{label}</Typography>
      </Box>
      <Box>
        <Typography variant="h6" sx={{ color: "primary" }}>
          Balance: ${(data?.Investment + data?.Return).toLocaleString("en-US")}
        </Typography>
      </Box>
      <Box>
        <Typography sx={{ color: "grey" }}>
          Investment: {data.Investment.toLocaleString("en-US")}
        </Typography>
      </Box>
      <Box>
        <Typography sx={{ color: "grey" }}>
          Return: {data.Return.toLocaleString("en-US")}
        </Typography>
      </Box>
    </Container>
  );
};

export default CustomGraphTooltip;
